/**
 * switch and save modal
 */
(() => {
  const modal = document.getElementById('myModal');
  const btn = document.getElementById('myModalButton');
  const span = document.getElementById('closeModal');

  if (!btn) {
    return;
  }

  const form = document.querySelector('.js-modal-form');
  form.classList.remove('hidden');
  document.querySelector('.js-switch-save').append(form);
  document.querySelector('.js-switch-save form > button').innerHTML = 'Submit';

  // Open the modal when button is clicked
  btn.onclick = (e) => {
    e.preventDefault();
    modal.style.display = 'block';
  };

  // Close the modal when 'x' is clicked
  span.onclick = () => {
    modal.style.display = 'none';
  };

  // Close the modal when user clicks outside of it
  window.onclick = (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  };
})();
